import { Checkbox, FormControl, InputLabel, ListItemText, MenuItem, OutlinedInput, Select, ThemeProvider } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import Chart from 'react-apexcharts';
import { useTranslation } from 'react-i18next';

import { SelectComponent } from '../../../Components/shared/ReusableSmallComponents';
import SelectPeriod from '../../../Components/shared/SelectPeriod';
import { PeriodeDashboard } from '../../../data/Interfaces';
import useWindowSize from '../../../hooks/useWindowSize';
import { FieldComponentFont } from '../../../Styles/componentStyles';
import { filtreListPeriode } from '../DashbordBackOffice';

export const StatutsMisionEnum=[
    {
        value: 'encours',
        label: 'En cours', //! ne change pas cette label car c'est liee avec getStatutMissionEncourCaseWithDateNotStartingYet
    },
    {
        value: 'interompu',
        label: 'Interrompue',
    },
    {
        value: 'terminee',
        label: 'Terminée',
    },
    {
        value: 'aVenir',
        label: 'En attente de validation',//À venir
    },
    {
        value: 'annulee',
        label: 'Annulée',
    },
    {
        value: 'interruptionEnCours',
        label: 'Interruption en cours',
    },
    {
        value: 'all',
        label: 'Tout les status',
    },
];
export const sourceMission = [
    {label:'AO',value:'ao'},
    {label:'Cvtheque',value:'cvtheque'},
    {label:'Tout',value:'all'}
];
function StatutMissionExpert({allStatusMissions,width,height}){

    StatutMissionExpert.propTypes = {
        allStatusMissions: PropTypes.any,
        width:PropTypes.any,
        height:PropTypes.any,
    };

    const { inputSize } = useWindowSize();
    const [filtreSourceMission, setFiltreSourceMission] = useState(['all']);
    const [selectedStatutMission, setSelectedStatutMission] = useState(['all']);
    const [selectedPeriodMission, setSelectedPeriodMission] = useState('thisMonth'); // Default selected period
    const [customDateRangeMission, setCustomDateRangeMission] = useState({});
    const { i18n } = useTranslation();
    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250,
            },
        },
    };
    const [chartDataStatusMission, setChartDataStatusMission] = useState({
        series: [],
        chart: {
            type: 'bar',
            stacked: true,
            stackType: '50%',
            toolbar: {
                show: true
            },
            zoom: {
                enabled: true
            }

        },
        options: {

            labels: [],
            bar : {
                columnWidth: '20px',
            },

            plotOptions: {
                bar: {
                    horizontal: false,
                }
            },
            stroke: {
                show: true,
                width: 5,
                colors: ['transparent'],
            },
            responsive: [{
                breakpoint: 480,
                options: {
                    legend: {
                        position: 'bottom',
                        offsetX: -10,
                        offsetY: 0
                    }
                }
            }],
            legend: {
                position: 'bottom',
                offsetY: 40
            },
            yaxis: {
                type: 'numeric', // Specify the type as 'numeric'
                labels: {
                    formatter: function (val) {
                        // Use a formatter function to format the labels as integers
                        return Math.round(val);
                    },
                },
            },
            fill: {
                opacity: 1
            }
        },
    });

    const groupByDate = (data) => {
        const result = data.reduce((acc, item) => {
            const keyDate = item.dateDebutAO.substring(0, 7);
            const keyNom = item.nom;

            if (!acc[keyDate]) {
                acc[keyDate] = {};
            }

            if (!acc[keyDate][keyNom]) {
                acc[keyDate][keyNom] = 0;
            }

            acc[keyDate][keyNom]=acc[keyDate][keyNom]+1;
            return acc;
        }, {});

        const uniqueNoms =[];

        Object.values(result).forEach((dateObj) => {
            Object.keys(dateObj).forEach((nom) => {
                if(!uniqueNoms.includes(nom))
                    uniqueNoms.push(nom);
            });
        });

        return {result,uniqueNoms};
    };

    const calculateCAByPeriodeAndEchancier = (data) => {
        const {result,uniqueNoms} = groupByDate(data);
        // Construct the final arrays for each periode
        const periodes = Object.keys(result);
        const sortedPeriodes = periodes.slice().sort((a, b) => {
            return new Date(a) - new Date(b);
        });
        const backofficeArrays = uniqueNoms.map((value) =>
            sortedPeriodes.map((periode) => result[periode][value] || 0)
        );

        return {sortedPeriodes,backofficeArrays,uniqueNoms};
    };

    useEffect(()=>{
        if(Array.isArray(allStatusMissions)){
            var filteredData=filtreListPeriode(allStatusMissions,selectedPeriodMission,customDateRangeMission);

            if (!selectedStatutMission.includes('all')) {
                filteredData = filteredData.filter(
                    (item) => selectedStatutMission.includes(item.statutMission)
                );
            }

            if (filtreSourceMission != 'all') {
                filteredData = filteredData.filter(
                    (item) => item.sourceMission == filtreSourceMission
                );
            }

            const {sortedPeriodes,backofficeArrays,uniqueNoms}=calculateCAByPeriodeAndEchancier(filteredData);

            setChartDataStatusMission((prevState) => {
                return {
                    ...prevState,
                    series:uniqueNoms.map((office, index) => ({
                        name: office,
                        data: backofficeArrays[index],
                    })),
                    options: {
                        ...prevState.options,
                        xaxis: {
                            ...prevState.options.xaxis,
                            //type: 'date',
                            categories: sortedPeriodes
                            //Array.isArray(CountsListStatusCandidatures) ? CountsListStatusCandidatures.map((item) => item.date) : [],
                        },
                        plotOptions: {
                            ...prevState.options.plotOptions,
                            bar: {
                                ...prevState.options.plotOptions.bar,
                                columnWidth: '25%',
                                rangeBarOverlap: true,
                                rangeBarGroupRows: false
                            },
                        },
                    },
                };
            });
        }
    },[allStatusMissions,customDateRangeMission,filtreSourceMission,selectedStatutMission]);

    return (
        <>
            <div
                className='graph1'
                style={{width:width,height:height}}
            >
                <h1 className='dashFrame5'>{i18n.t('Analyse des missions')}</h1>
                <div className='filtre1'>
                    <div style={{width:'25%'}}>
                        <SelectPeriod
                            selectedPeriod={selectedPeriodMission}
                            setSelectedPeriod={setSelectedPeriodMission}
                            setCustomDateRange={setCustomDateRangeMission}
                            listeVal={PeriodeDashboard}

                        />
                    </div>

                    <div style={{width:'25%'}}>
                        <ThemeProvider theme={FieldComponentFont}>
                            <FormControl style={{width:'100%'}}>
                                <InputLabel
                                    shrink={true}
                                    id="demo-multiple-checkbox-label"
                                >{i18n.t('Statut mission')} </InputLabel>
                                <Select
                                    labelId="demo-multiple-checkbox-label"
                                    id="demo-multiple-checkbox"
                                    multiple
                                    label={i18n.t('Statut mission')}
                                    value={selectedStatutMission}
                                    onChange={(event)=>{
                                        const {
                                            target: { value },
                                        } = event;
                                        console.log('typeof value ===',typeof value === 'string' ? value.split(',') : value);
                                        setSelectedStatutMission(
                                        // On autofill we get a stringified value.
                                            typeof value === 'string' ? value.split(',') : value,
                                        );
                                        if(value.length>0){
                                            if (value[value.length - 1] == 'all') {
                                                setSelectedStatutMission(['all']);
                                            } else {
                                                // If 'all' was selected before, remove it from selectedClientCheckBox
                                                const updatedSelected = value.includes('all')
                                                    ? value.filter((item) => item !== 'all')
                                                    : value;
                                                console.log('updatedSelected',updatedSelected);

                                                setSelectedStatutMission(updatedSelected);
                                            }
                                        }
                                    }}
                                    size={inputSize}
                                    sx={{
                                        '& > :not(style)': {borderRadius: '8px' },
                                    }}
                                    style={{ width: '100%', background: 'white' }}
                                    input={<OutlinedInput label="Statut mission" />}
                                    renderValue={(selected) => {
                                        return selected
                                            .map((value) => {
                                                const selectedOption = StatutsMisionEnum.find(
                                                    (element) => element.value === value
                                                );
                                                return i18n.t(selectedOption?.label);
                                            })
                                            .join(', ');
                                    }}
                                    MenuProps={MenuProps}
                                >
                                    {StatutsMisionEnum?.map((element) => (
                                        <MenuItem
                                            key={element.value}
                                            value={element.value}
                                        >
                                            <Checkbox checked={selectedStatutMission.includes(element.value)} />
                                            <ListItemText primary={i18n.t(element.label)} />
                                        </MenuItem>
                                    ))}

                                </Select>
                            </FormControl>
                        </ThemeProvider>
                    </div>

                    <div style={{width:'25%'}}>
                        <SelectComponent
                            label={i18n.t('Source')}
                            val={filtreSourceMission}
                            name='statusAoCandidatures'
                            setVal={(event)=>{
                                setFiltreSourceMission(event.target.value);
                            }}
                            listVal={sourceMission}
                        />
                    </div>
                </div>
                <div style={{height:'400px'}}>
                    <Chart
                        options={chartDataStatusMission.options}
                        series={chartDataStatusMission.series}
                        type="bar"
                        height={'85%'}
                        width={'100%'}
                    />
                </div>
            </div>
        </>
    );

}
export default StatutMissionExpert;